import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Information from '../views/Information.vue'
import Slider from '../views/Slider.vue'
import Category from '../views/greenbook/Category.vue'
import SingleService from '../views/greenbook/SingleService.vue'
import Search from '../views/Search.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    props: route => ({ query: route.query.q })
  },
  {
    path: '/about',
    name: 'About',
    component: About
  
  },
  {
    path: '/supplementary-information',
    name: 'Information',
    component: Information
  
  },
  {
   path: '/slider',
   name: 'Slider',
   component: Slider,
   props: true
 },
  {
    path: '/category/:org',
    name: 'Category',
    component: Category,
    props: true
  },
  {
    path: '/:title',
    name: 'SingleService',
    component: SingleService,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  routes
})


export default router
